import { render, staticRenderFns } from "./ClassScheduleCourseItem.vue?vue&type=template&id=b5b6b3ae&scoped=true"
import script from "./ClassScheduleCourseItem.vue?vue&type=script&lang=js"
export * from "./ClassScheduleCourseItem.vue?vue&type=script&lang=js"
import style0 from "./ClassScheduleCourseItem.vue?vue&type=style&index=0&id=b5b6b3ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b6b3ae",
  null
  
)

export default component.exports